import { render } from "./messageShow.vue?vue&type=template&id=4bf47a44&scoped=true"
import script from "./messageShow.vue?vue&type=script&lang=js"
export * from "./messageShow.vue?vue&type=script&lang=js"

import "./messageShow.vue?vue&type=style&index=0&id=4bf47a44&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf47a44"]])

export default __exports__